// Pure view logic for the portrait shorts player. Everything here is testable
// without a DOM video element — jsdom cannot play video, so anything needing
// real playback is verified by hand instead.

// A clip must be this visible before it takes over as the active one.
export const ACTIVE_THRESHOLD = 0.6;

// How many clips either side of the active one keep a live HLS instance.
// Mobile Safari caps simultaneous media elements: without this window, scrolling
// quickly through a long list silently stops playing anything at all.
export const HLS_WINDOW_RADIUS = 1;

export function activeIndexFromEntries(entries, currentIndex) {
    const list = Array.isArray(entries) ? entries : [];
    let bestIndex = currentIndex;
    let bestRatio = ACTIVE_THRESHOLD;
    list.forEach((entry) => {
        const raw = entry && entry.target && entry.target.dataset
            ? entry.target.dataset.index
            : undefined;
        const index = parseInt(raw, 10);
        if (Number.isNaN(index)) {
            return;
        }
        const ratio = entry.intersectionRatio || 0;
        if (ratio >= bestRatio) {
            bestRatio = ratio;
            bestIndex = index;
        }
    });
    return bestIndex;
}

export function hlsWindowIndices(activeIndex, total, radius = HLS_WINDOW_RADIUS) {
    const indices = [];
    for (let i = activeIndex - radius; i <= activeIndex + radius; i += 1) {
        if (i >= 0 && i < total) {
            indices.push(i);
        }
    }
    return indices;
}

export function activeCue(segments, currentTime) {
    const list = Array.isArray(segments) ? segments : [];
    const found = list.find(segment => currentTime >= segment.start && currentTime < segment.end);
    return found || null;
}

// Client-side twin of backend/lib/video-orientation.js classifyOrientation,
// fed by a <video> element's videoWidth/videoHeight (post-rotation in
// browsers). Used only for the non-blocking "this is landscape" hint in the
// capture drawer - the authoritative classification still happens server-side
// from the Lambda poster frame.
export function classifyClientOrientation(width, height) {
    const w = Number(width);
    const h = Number(height);
    if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        return null;
    }
    if (w === h) {
        return 'square';
    }
    return w > h ? 'landscape' : 'portrait';
}

export default {
    activeIndexFromEntries,
    hlsWindowIndices,
    activeCue,
    classifyClientOrientation,
    ACTIVE_THRESHOLD,
    HLS_WINDOW_RADIUS,
};
